import { useStore } from '@nanostores/react';
import { AnimatePresence, cubicBezier, motion } from 'framer-motion';
import { supabaseStore } from '~/lib/stores/supabase';

interface SendButtonProps {
  disabled?: boolean;
  isStreaming?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const customEasingFn = cubicBezier(0.4, 0, 0.2, 1);

export function SendButton({ isStreaming, onClick, disabled }: SendButtonProps) {
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);

  return (
    <button
      className="flex justify-center overflow-hidden items-center p-1 bg-accent-500 hover:brightness-94 color-white rounded-full size-7 transition-theme disabled:cursor-not-allowed disabled:opacity-50"
      disabled={disabled || supabaseStatus === 'CONNECTING'}
      onClick={(event) => {
        event.preventDefault();
        onClick?.(event);
      }}
    >
      <div className="text-lg">
        <AnimatePresence initial={false} mode="wait">
          {isStreaming ? (
            <motion.div
              key="stop"
              className="i-heroicons:stop-solid size-4"
              initial={{ opacity: 0, scale: 0.5, filter: 'blur(4px)', rotate: -180 }}
              animate={{ opacity: 1, scale: 1, filter: 'blur(0px)', rotate: 0 }}
              exit={{ opacity: 0, scale: 0.5, filter: 'blur(4px)', rotate: -180 }}
              transition={{ ease: customEasingFn, duration: 0.2 }}
            ></motion.div>
          ) : (
            <motion.div
              key="arrow"
              className="i-heroicons-outline:arrow-up size-4"
              initial={{ opacity: 0, scale: 0.5, filter: 'blur(4px)' }}
              animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
              exit={{ opacity: 0, scale: 0.5, filter: 'blur(4px)', y: -12 }}
              transition={{ ease: customEasingFn, duration: 0.2 }}
            ></motion.div>
          )}
        </AnimatePresence>
      </div>
    </button>
  );
}
